import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { PortfolioViewModel } from 'src/app/view-models/portfolio.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent extends BaseComponent<PortfolioViewModel> implements OnInit {

  constructor(commonService: CommonService, logService: LogHandlerService) {
    super(commonService,logService);
    this.viewModel=new PortfolioViewModel();
  }

  ngOnInit(): void {
  }

}
